// extracted by mini-css-extract-plugin
module.exports = {"MediaBlockIncutCard":"di1Wr","MediaBlockIncutCard_vertical":"TTMwr","MediaBlockSlider":"KqCJE"};